import React, {Component} from "react";
import _ from 'i18n';
import {Col, Row, Tooltip} from "antd";

export default class FacturationStatsCardRow extends Component {

  render() {
    const {
      personsNumber,
      registrationsNumber,
      label,
      marginBottom
    } = this.props;

    return (
      <Row className={'card-app-type-row'}
           style={marginBottom === true ? {marginBottom: '10px'} : {}}>
        <Col className={'card-app-type-col'}
             style={{borderRight: '1px solid #D8DDE2'}} span={12}>
          <span
            className={'card-app-type-detail-number'}>{personsNumber >= 10 ? personsNumber : '0' + personsNumber}</span>
          <br/>
          <span className={'card-app-type-label'}>{_('PERSONS')}</span>
        </Col>
        <Col className={'card-app-type-col'} span={12}>
          <span
            className={'card-app-type-detail-number'}>{registrationsNumber >= 10 ? registrationsNumber : '0' + registrationsNumber}</span>
          <br/>
          <span className={'card-app-type-label'}>{label}</span>
        </Col>
      </Row>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/Facturation/FacturationStatsCardRow.js